import { SET_SOURCE_RATING_IMPORT } from "./actions";

export default {
  [SET_SOURCE_RATING_IMPORT](state, payload) {
    state.sourceRatingImport = payload;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};
